import { render, staticRenderFns } from "./pictures.vue?vue&type=template&id=deb6865e&scoped=true&"
import script from "./pictures.vue?vue&type=script&lang=js&"
export * from "./pictures.vue?vue&type=script&lang=js&"
import style0 from "./pictures.vue?vue&type=style&index=0&id=deb6865e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb6865e",
  null
  
)

export default component.exports